import { TemplateSet } from '@/types/bannerTemplate';

// Template sets are managed via the banner_templates storage in production.
// This array is intentionally empty; admins add real template sets from the
// Master Admin > Banner Templates screen.
export const TEMPLATE_SETS: TemplateSet[] = [];
